import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { RemotelockPin } from '../../../models';

import styles from './DoorList.module.scss';

interface PingCodesProps {
  codes: RemotelockPin[];
  helpText?: string;
}

export const PinCodesList = ({ codes, helpText }: PingCodesProps) => {
  const intl = useIntl();

  const renderPinCodesList = useCallback(() => {
    if (!codes?.length) {
      return (
        <div className={styles.empty}>
          {intl.formatMessage({
            id: 'digital_keys/no_ping_codes_found',
            defaultMessage: 'No ping codes found',
          })}
        </div>
      );
    }

    return (
      <>
        {codes.map((code) => (
          <div key={code.id} className={styles.item}>
            <span>{code.door_name}</span>
            <span style={{ fontWeight: 'bold' }}>{code.access_pin}</span>
          </div>
        ))}
        <div className={styles.space} />
      </>
    );
  }, [codes, intl]);

  return (
    <div className={styles.list}>
      <header className={styles.header}>
        {intl.formatMessage({
          id: 'digital_keys/pin_codes',
          defaultMessage: 'PIN codes',
        })}
      </header>
      {helpText && <span className={styles.help_text}>{helpText}</span>}
      {renderPinCodesList()}
    </div>
  );
};
